/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Types_HintInputs */

const vi_shop_home_link_types_hint = /** @type {(inputs: Shop_Home_Link_Types_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Như bộ lọc "Loại" trên web: suy từ tên quy cách (vd "Bộ hộp sứ 400g" thuộc Bộ hộp và Hộp sứ / gỗ / kim tuyến).`)
};

/**

* @param {Shop_Home_Link_Types_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_types_hint = /** @type {((inputs?: Shop_Home_Link_Types_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Types_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_types_hint(inputs)
});